import NewsList from "../components/display/NewsList";
import NewsData from "../data/content/NewsData";
import Container from "react-bootstrap/Container";
import TeamData from "../data/content/TeamData";
import PageHeader from "../components/display/PageHeader";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import classes from "./Page.module.css";
import TeamMemberListShort from "../components/display/TeamMemberListShort";

function MainPage(props) {
  return (
    <div>
      <Container className={classes.headingContainer}>
        <Row className="justify-content-md-center">
          <Col md={3} sm={3}>
            <img
              src={props.logo}
              alt="author-pic"
              className={classes.titleImage}
            />
          </Col>
          <Col md={9} sm={9}>
            <h2 className={classes.headingMain}>
              Natural Language Learning & Generation (NLLG = NL²G) Lab
            </h2>
            <h4 className={classes.subHeadingMain}>
              Squaring Natural Language Processing!
            </h4>
          </Col>
        </Row>
        <Row className="justify-content-md-center">
          <Col md={11} sm={11}>
            <p>
              The Natural Language Learning & Generation (NLLG) Lab at TU Nürnberg focuses on problems of{" "}
              <b>text generation</b> (in humanities contexts; such as poetry
              generation), <b>evaluation of text generation</b>, as well as
              problems at the intersection of{" "}
              <b>Natural Language Processing (NLP)</b>, the <b>digital humanities</b> and the <b>social sciences</b>. The NLLG
              lab is headed by{" "}
              <a href="https://steffeneger.github.io/">Steffen Eger</a> (Full Professor at TU Nürnberg) and supported by the DFG through a Heisenberg grant and by the BMBF via the research group grant "Metrics4NLG". Current team
              members are:
            </p>
          </Col>
        </Row>
        <TeamMemberListShort teamData={TeamData} />
        <p className={classes.mainText}>
          Follow us on Twitter:{" "}
          <a href="https://twitter.com/NLLG_lab">
            https://twitter.com/NLLG_lab
          </a>{" "}! Or contact us via <a href="mailto:nllg@utn.de">email.</a>
        </p>
      </Container>

      <Container className={classes.container}>
        <PageHeader
          headerText="News"
          headerImage={require("../data/content/images/news1.png")}
          headerImageAlt="Projects"
          headerDescription="Latest news of our group."
        />
        <NewsList newsData={NewsData} />
      </Container>
    </div>
  );
}

export default MainPage;
